import { RootState } from 'store/reducer';

export const selectWatchlistUuids = (state: RootState) =>
  state.watchlist.watchlistUuids;

export const selectWatchlistLoadingState = (state: RootState) =>
  state.watchlist.watchlistLoadingState;
